export enum ABTestDrawdownControls {
    AGE = 'AGE',
    INCOME = 'INCOME',
}

export type ABTestProps = {
    drawdownControl: ABTestDrawdownControls;
};

export type ABTestContextValue = ABTestProps & {
    updateABTestState: (props: ABTestProps) => void;
};
